import React from "react";
import { useRouter } from "next/router";

export default function useSlugUrl({ slug, id, isPreview = false }) {
  const router = useRouter();

  React.useEffect(() => {
    if (router.query.slug !== slug && !isPreview) {
      let fixedRoute = router.route.replaceAll("[slug]", slug);
      fixedRoute = fixedRoute.replaceAll("[id]", id);
      router.push(fixedRoute, undefined, { shallow: true });
    }
  }, [router, id, slug, isPreview]);

  return { path: router.asPath };
}
